module.exports = __webpack_public_path__ + "static/media/thermometer-half.5ea62b05.svg";